export default {

  methods: {

    // datalayer variables
    // event : 'click'
    // click_name: 'search_topnav' or 'search_hero'
    // other dayalayer variables: search_regions, search_from, search_to, search_people, search_beds

    /// tracks a search click and pushes all filters as custom DataLayer variables onto the datalayer
    trackSearchClick(clickname, searchFilters) {
      try {
        console.log(searchFilters);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
          {
            event: 'click',
            click_name: `${clickname}`,
            search_from: searchFilters.from ? `${searchFilters.from}` : '',
            search_to: searchFilters.to ? `${searchFilters.to}` : '',
            search_beds: searchFilters.rooms ? `${searchFilters.rooms}` : '',
            search_people: searchFilters.people ? `${searchFilters.people}` : '',
            search_regions: searchFilters.destinations ? `${searchFilters.destinations.map((d) => d).join(',')}` : '',
            search_regions_names: searchFilters.desNames ? `${searchFilters.desNames.map((d) => d).join(',')}` : '',
          },
        );
      } catch (err) {
        console.log(err);
      }
    },

  },

};
